import React from 'react';
import { Button, Icon } from "semantic-ui-react";

const SummaryButton = (props) => {
    return (
        <Button compact color='blue' icon size='mini' disabled={props.disabled} onClick={props.onClick} className={props.className}>
            <Icon name="pin" rotated={ !props.active ? "clockwise" : null } />
        </Button>
    )
}

export default SummaryButton;